import { format } from "date-fns";
import { RecruiterService } from "../../services/RecruiterService";
import { StorageConstants } from "../../storage/storageConstants";
import {
  APPEND_RECRUITER_PROFILE_LIST,
  SET_LOADING,
  SET_RECRUITER,
  SET_RECRUITER_AUDITION,
  SET_RECRUITER_IMAGES,
  SET_RECRUITER_LIST,
  SET_RECRUITER_LIST_META,
  SET_RECRUITER_PROFILE,
  SET_RECRUITER_PROFILE_LIST,
  SET_RECRUITER_PROFILE_LIST_META,
  SET_SELECTED_RECRUITER,
} from "./types";
import { replaceCountryCode } from "../../../utils";
import { StatusCodes } from "../../network/Configurations";
import dayjs from "dayjs";

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to set Recruiter list
 */
export const setRecruiterList = (data) => ({
  type: SET_RECRUITER_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to set Recruiter list meta
 */
export const setRecruiterListMeta = (data) => ({
  type: SET_RECRUITER_LIST_META,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to set Recruiter data
 */
export const setRecruiter = (data) => ({
  type: SET_RECRUITER,
  payload: data,
});

/**
 * @author Dhanu Kr Kesharwani.
 * @since 20-02-2025.
 * @description to set Recruiter Profile list
 */
export const setRecruiterProfileList = (data) => ({
  type: SET_RECRUITER_PROFILE_LIST,
  payload: data,
});

/**
 * @author Dhanu Kr Kesharwani.
 * @since 20-02-2025.
 * @description to set Recruiter Profile list meta
 */
export const setRecruiterProfileListMeta = (data) => ({
  type: SET_RECRUITER_PROFILE_LIST_META,
  payload: data,
});

/**
 * @author Dhanu Kr Kesharwani.
 * @since 20-02-2025.
 * @description to set Recruiter Profile data
 */
export const setRecruiterProfile = (data) => ({
  type: SET_RECRUITER_PROFILE,
  payload: data,
});

export const appendRecruiterProfile = (data) => ({
  type: APPEND_RECRUITER_PROFILE_LIST,
  payload: data,
});

/**
 * @author Dhanu Kr Kesharwani
 * @since 20-02-2025
 * @description to set the selected recruiter ID
 */
export const setSelectedRecruiter = (data) => ({
  type: SET_SELECTED_RECRUITER,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to set Recruiter data
 */
export const setRecruiterAuditions = (data) => ({
  type: SET_RECRUITER_AUDITION,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set Recruiter Image
 */
export const setRecruiterImages = (data) => ({
  type: SET_RECRUITER_IMAGES,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
  type: SET_LOADING,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to get Recruiter list
 */
export const getRecruiterList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await RecruiterService.getRecruiterList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setRecruiterList(res?.data[0]));
        await dispatch(setRecruiterListMeta(res?.metadata));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Recruiter list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Dhanu Kr Kesharwani.
 * @since 20-02-2025.
 * @description to get Recruiter Profile list
 */
// export const getRecruiterProfileList =
//   (params, successCallback, errorCallback) => async (dispatch) => {
//     await dispatch(setLoading(true));
//     await RecruiterService.getRecruiterProfileList(params)
//       .then(async (res) => {
//         console.log("Result: ", res);
//         await dispatch(setRecruiterProfileList(res?.data[0]));
//         await dispatch(setRecruiterProfileListMeta(res?.metadata));
//         successCallback?.();
//       })
//       .catch(async (err) => {
//         console.log("Recruiter Profile list Error: ", err);
//         errorCallback?.(err);
//       })
//       .finally(() => {
//         dispatch(setLoading(false));
//       });
//   };

export const getRecruiterProfileList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(
      setRecruiterProfileListMeta({ loading: true, hasMore: true })
    );
    const metaData = { loading: false, hasMore: true };
    await RecruiterService.getRecruiterProfileList({ ...params })
      .then(async (res) => {
        console.log("Result: ", res);
        if (res.code === StatusCodes.NO_DATA_FOUND) {
          metaData.hasMore = false;
          if (params?.page <= 1) await dispatch(setRecruiterProfileList([]));
        } else if (params?.page <= 1) {
          await dispatch(setRecruiterProfileList(res?.data?.[0] || []));
        } else {
          await dispatch(appendRecruiterProfile(res?.data?.[0] || []));
        }
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Recruiter Videos list Error: ", err);
        errorCallback?.(err);
      })
      .finally(async () => {
        await dispatch(setRecruiterProfileListMeta(metaData));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to get Recruiter By id
 */
export const getRecruiterById =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await RecruiterService.getRecruiterById(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setRecruiter(res?.data[0]));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Recruiter list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to delete Recruiter profiles
 */
export const deleteRecruiterProfiles =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await RecruiterService.deleteRecruiters(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setRecruiter(""));
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in logout: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to delete Recruiter profiles
 */
export const markRecruiterVerified =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await RecruiterService.markRecruiterVerified(params)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in logout: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @description to get Recruiter Auditions By id
 */
export const getRecruiterAuditions =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await RecruiterService.getAuditionListForRecruiter(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setRecruiterAuditions(res?.data[0]));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Recruiter audition list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to get Recruiter Image By id
 */
export const getRecruiterImages =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await RecruiterService.getImagesList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setRecruiterImages(res?.data[0]));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Recruiter Images list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

export const fetchRecruiterDataById =
  (params, successCallback, errorCallback) => async (dispatch) => {
    let promises = [];
    promises.push(dispatch(getRecruiterById(params, () => {}, errorCallback)));
    promises.push(
      dispatch(getRecruiterAuditions(params, () => {}, errorCallback))
    );
    promises.push(
      dispatch(getRecruiterImages(params, () => {}, errorCallback))
    );
    return Promise.all(promises)
      .then((res) => successCallback())
      .catch((err) => console.log(err))
      .finally(() => dispatch(setLoading(null)));
  };

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to update Recruiter profile
 */
export const updateRecruiterProfile =
  (data, successCallback, errorCallback) => async (dispatch) => {
    const request = {
      userId: data?.userId,
      firstName: data?.firstName,
      lastName: data?.lastName,
      contactVisibility: data?.contactVisibility,
      userProfile: {
        gender: data?.gender,
        profileCategory: { id: data?.profileCategoryId },
        location: data?.location,
        dob: format(new Date(data?.dob), "yyyy-MM-dd"),
        bio: data?.bio,
        businessMobileNo: replaceCountryCode(data?.businessMobileNo),
        businessEmail: data?.businessEmail,
        nationality: data?.nationality,
        companyName: data?.companyName,
        experienceCategory: data?.experienceCategory,
        experienceYears: data?.experienceYears,
      },
    };
    await RecruiterService.updateRecruiter(request)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in updating recruiter: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to add Recruiter profile
 */
export const addRecruiterProfile =
  (data, successCallback, errorCallback) => async (dispatch) => {
    const dob = data?.dob ? dayjs(data.dob).format("MM-DD-YYYY") : null;

    const request = {
      firstName: data?.firstName ?? "",
      lastName: data?.lastName ?? "",
      mobileNo: replaceCountryCode(data?.mobileNo) ?? "",
      contactVisibility: data?.contactVisibility ?? "",
      email: data?.email ?? "",
      userProfile: {
        profileCategory: {
          id: data?.profileCategoryId ?? "",
        },
        location: data?.location ?? "",
        gender: data?.gender ?? "",
        dob: dob,
        bio: data?.bio ?? "",
        businessMobileNo: replaceCountryCode(data?.businessMobileNo) ?? "",
        businessEmail: data?.businessEmail ?? "",
        nationality: data?.nationality ?? "",
        companyName: data?.companyName ?? "",
        experienceCategory: data?.experienceCategory ?? "",
        experienceYears: data?.experienceYears ?? "",
      },
    };
    await RecruiterService.addRecruiter(request)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in updating recruiter: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
